import React, {Component} from 'react';
import {ScrollBox, Page, Svg} from '../../index';
import {OperatBtn} from "./subpage"

import {styleObj} from './styles';

Array.prototype.S = String.fromCharCode(2);
Array.prototype.in_array = function (e) {
    let r = new RegExp(this.S + e + this.S);
    return (r.test(this.S + this.join(this.S) + this.S));
};
let clickCount = 0;
class TableField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: styleObj,
            tableData: [],
            tableObj: [],
            // shouldUpdate: true,
            bgColor: '',
            textColor: '',
            _bgColor: '',
            _textColor: '',
            as: false,//是否点击升序
            de: false,//是否点击降序

            itemArr: [],
            itemData: [],
            selectAll: false,


            moveElement: {},
            showColResize: false,
            mouseDown: false,

            oldElemX: "",
            oldMouseX: "",

        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            tableData: nextProps.tableData,
            tableObj: nextProps.tableObj
        })
    }

    componentDidMount() {

        for (let i of this.props.tableObj) {
            i.show = false
        }
        this.setState({
            tableData: this.props.tableData,
            tableObj: this.props.tableObj
        })

        // const _this = this;
        // window.addEventListener('mouseup', function (e) {
        //     if (!_this.state.mouseDown) return;
        //     _this.setState({
        //         moveElement: {},
        //         mouseDown: false,
        //         showColResize: false,
        //     })
        // });
    }

    // initScroll = () => {
    //     this.setState({ shouldUpdate: false });
    // };
    mouseOver = (index, data) => {

        data[index].show = true;
        this.setState({
            tableObj: data
        })
    };
    mouseOut = (index, data) => {

        data[index].show = false;
        this.setState({
            tableObj: data
        })
    };
    overColor = () => {
        this.setState({
            bgColor: "#ccc",
            textColor: "white",
        })
    };
    outColor = () => {
        this.setState({
            bgColor: "#f9f9f9",
            textColor: "#888",

        })
    };
    _overColor = () => {
        this.setState({
            _bgColor: "#ccc",
            _textColor: "white"
        })
    };
    _outColor = () => {
        this.setState({
            _bgColor: "#f9f9f9",
            _textColor: "#888",
        })
    };

    handleClick = (value) => {
        clickCount++;
        setTimeout(() => {
            if (clickCount == 1) {
                this.setSelectItem(value)
            } else if (this.props.checkType == "radio" && clickCount == 2) {
                this.setState({
                    itemArr: [value.tableId],
                    itemData: [value]
                });
                this.props.handleDoubleClick && this.props.handleDoubleClick(value);
            }
            clickCount = 0
        }, 200)
    };
    setSelectItem = (value) => {
        if (this.props.checkType == "radio") {
            this.setState({
                itemArr: [value.tableId],
                itemData: [value]
            });
            this.props.handleItem && this.props.handleItem(value, "radio")
        } else {
            let itemArr = this.state.itemArr;
            let itemData = this.state.itemData;
            let num = itemArr.indexOf(value.tableId);
            if (num > -1) {
                itemArr.splice(num, 1);
                itemData.splice(num, 1);
            } else {
                itemArr.push(value.tableId);
                itemData.push(value);
            }
            this.setState({
                itemArr,
                itemData
            });
            this.props.handleItem && this.props.handleItem(itemData, "checkbox")
        }
    };
    setSelectItemAll = () => {
        let selectAll = this.state.selectAll;
        let itemArr = [];
        let itemData = [];
        let tableData = this.state.tableData;
        if (!selectAll) {
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].isChoose) {
                    itemArr.push(tableData[i].tableId);
                    itemData.push(tableData[i])
                }
            }
        }
        this.setState({
            selectAll: !selectAll,
            itemArr,
            itemData
        })
    };
    handleSequence = (type, property, data, index, array) => {

        var sortObj = data.sort((prev, next) => {

            let a = prev[property];
            let b = next[property];
            for (let i of array) {
                i.as = false;
                i.de = false;
            }
            //升序 ascending

            if (type == "ascending") {

                array[index].as = true;
                array[index].de = false;
                this.setState({
                    tableObj: array
                });
                return a.toString().localeCompare(b)
            }

            //降序descending
            if (type == "descending") {
                array[index].as = false;
                array[index].de = true;
                this.setState({
                    tableObj: array
                });
                return b.toString().localeCompare(a)
            }

            // return function (obj1, obj2) {
            //     let a = obj1[property];
            //     let b = obj2[property];
            //     return type == "ascending" ? a.toString().localeCompare(b) :
            //         type == "descending" ? b.toString().localeCompare(a) : 0
            // }
        });
        this.setState({
            tableData: sortObj
        });

        array[index].show = false;
        this.setState({
            tableObj: data
        })

    };
    handleScroll = (e) => {

        document.getElementById('table').scrollTop = e.currentTarget.scrollTop;

    };
    handleBtn = (item) => {
        let itemData = this.state.itemData;
        let tableData = this.state.tableData;
        itemData = itemData.filter((item, index) => {
            return tableData.some((tItem, index) => item.tableId == tItem.tableId)
        });
        this.props.handleBtn(itemData, item.type)
    };


    onMouseDownFn = (item, e)=> {
        if (this.state.showColResize) {
            const oldElemW = e.target.offsetWidth;
            const oldElemX = e.target.getBoundingClientRect().x;
            const oldElemR = oldElemX + e.target.offsetWidth;
            const oldMouseX = e.clientX;
            this.setState({
                mouseDown: true,
                oldElemW,
                oldElemX,
                oldElemR,
                oldMouseX,
                oldItem: item,
            })
        }

    };
    onMouseMoveFn = (item, type, e)=> {
        const elemX = e.target.getBoundingClientRect().x;
        const elemR = elemX + e.target.offsetWidth;
        const mouseX = e.clientX;

        this.setState({
            moveElement: item,
            showColResize: elemR > mouseX - 20 && elemR < mouseX + 20
        });

        if (this.state.mouseDown && mouseX > elemX) {
            const fontsize = parseFloat(getComputedStyle(window.document.documentElement)['font-size']);
            const newW = mouseX - this.state.oldElemX;
            if (newW > 0) {
                const tableObj = [].concat(this.state.tableObj);
                tableObj.forEach((item1)=> {
                    if (item1.fieldName == this.state.oldItem.fieldName) {
                        item1.fieldWidth = ((newW / fontsize) * (16 - fontsize) + newW) / 16 + "rem"
                    }
                });
                this.setState({
                    tableObj
                })
            }
        }

    };
    onMouseUpFn = (item, e)=> {
        this.setState({
            moveElement: {},
            mouseDown: false,
            showColResize: false,
        })
    };


    render() {
        const props = this.props, state = this.state;
        let styles = state.styles, tabWidth = 0, lockTabWidth = props.checkBox ? 5 : 2,
            tabBoxWidth = parseInt(props.width);

        state.tableObj.forEach(item=> {
            const width = parseInt(item.fieldWidth)
            item.isLock ? (lockTabWidth += width) : (tabWidth += width)
        });


        let minHeight = props.minHeight ? parseInt(props.minHeight) + 2.5 : 2.5;
        tabBoxWidth = tabBoxWidth - lockTabWidth;

        return (
            <div style={Object.assign({}, styles.table, {width: props.width})}>

                {OperatBtn(this, props, styles)}

                <div style={{position: "relative"}}>
                    <div style={{minHeight: minHeight + 'rem'}}>


                        <table className="tb-thead-1" style={Object.assign({}, styles["tb-thead-1"], {
                            width: lockTabWidth + "rem",
                        })}>
                            <thead style={styles.thead}>
                            <tr style={Object.assign({}, styles.lockTheadTr)}>

                                {props.checkBox && props.checkType != "radio" ?
                                    <td onClick={this.setSelectItemAll} style={styles.checkBox}>
                                        {this.state.selectAll ?
                                            <Svg type={props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                 width="1rem" height="1rem" fill="#4aa5fe"/> :
                                            <Svg type={props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                 width="1rem" height="1rem" fill="#ccc"/>
                                        }
                                    </td> : null
                                }

                                {state.tableObj.map((value, index, array) => (
                                        value.isLock ?
                                            <td id=""
                                                onMouseDown={this.onMouseDownFn.bind(this, value)}
                                                onMouseUp={this.onMouseUpFn.bind(this, value)}
                                                onMouseMove={this.onMouseMoveFn.bind(this, value, "thead1")}
                                                style={ this.state.moveElement.fieldName == value.fieldName &&
                                                this.state.showColResize ?
                                                {
                                                    width: value.fieldWidth,
                                                    cursor: "col-resize",
                                                    background: "pink",
                                                    borderRight: "red solid 0.0625rem",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%"
                                                } :
                                                {
                                                    width: value.fieldWidth,
                                                    background: "pink",
                                                    borderRight: "red solid 0.0625rem",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%"
                                                }
                                                }
                                                //onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                                //onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                                //style={{
                                                ///   cursor: value.isSequence ? "pointer" : null,
                                                //    width: value.fieldWidth
                                                // }}
                                                key={index}>

                                                {/*<div style={{*/}
                                                {/*display: "flex",*/}
                                                {/*justifyContent: "center",*/}
                                                {/*alignItems: "center"*/}
                                                {/*}}>*/}
                                                {value.fieldText}
                                                {value.isSequence ?
                                                    <div style={styles.sequenceSvg}>
                                                        <Svg type="Up" width="1rem" height="1rem"
                                                             fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                        <Svg type="Down" width="1rem" height="1rem"
                                                             fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                    </div> :
                                                    null
                                                }
                                                {/*</div>*/}

                                                {/* {value.isSequence ? (value.as ? " ↑" : value.de ? " ↓" : " ↑↓"): null} */}
                                                {/*  {<div style={{
                                                 cursor: "pointer",
                                                 width: value.fieldWidth,
                                                 position: "absolute",
                                                 display: value.show ? "block" : "none",
                                                 background: "#f9f9f9",
                                                 boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"
                                                 }}>
                                                 <div onMouseOver={this.overColor}
                                                 onMouseOut={this.outColor}
                                                 style={Object.assign({}, styles.sequenceItem, {
                                                 background: state.bgColor,
                                                 color: state.textColor
                                                 })}
                                                 onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>
                                                 升序 &nbsp; <Svg type="Up" width="1rem" height="1rem"
                                                 fill="#4aa5ff"/>
                                                 </div>
                                                 <div onMouseOver={this._overColor}
                                                 onMouseOut={this._outColor}
                                                 style={Object.assign({}, styles.sequenceItem, {
                                                 background: state._bgColor,
                                                 color: state._textColor
                                                 })}
                                                 onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>
                                                 降序 &nbsp; <Svg type="Down" width="1rem" height="1rem"
                                                 fill="#4aa5ff"/>
                                                 </div>
                                                 </div>
                                                 }*/}


                                            </td> : null
                                    )
                                )}
                            </tr>
                            </thead>
                        </table>


                        {/*tableBox:
                         tb-thead-1  | tb-thead-2
                         ———————————
                         tb-body-1  | tb-body-2

                         tb1
                         scroll{
                         | tb2
                         ———————————
                         tb3  | tb4
                         }
                         */}


                        <ScrollBox autohide={false}
                                   style={styles.tableBox}
                                   maxHeight={props.maxHeight ? props.maxHeight : '30rem'}
                                   updateScrollBar={props.updateScrollBar}
                        >


                            <table id="tb-thead-2" className="tb-thead-2"
                                   style={Object.assign({}, styles["tb-thead-2"], {
                                       width: tabBoxWidth + "rem",
                                       marginLeft: lockTabWidth + "rem",
                                   })}>
                                <thead style={styles.thead}>

                                <tr style={Object.assign({}, styles.theadTr)}>
                                    {state.tableObj.map((value, index, array) => (
                                        !value.isLock ?
                                            <td
                                                onMouseDown={this.onMouseDownFn.bind(this, value)}
                                                onMouseUp={this.onMouseUpFn.bind(this, value)}
                                                onMouseMove={this.onMouseMoveFn.bind(this, value, "thead2")}
                                                style={ this.state.moveElement.fieldName == value.fieldName &&
                                                this.state.showColResize ?
                                                {
                                                    width: value.fieldWidth,
                                                    cursor: "col-resize",
                                                    background: "pink",
                                                    borderRight: "red solid 0.0625rem",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%"
                                                } :
                                                {
                                                    width: value.fieldWidth,
                                                    background: "pink",
                                                    borderRight: "red solid 0.0625rem",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    height: "100%"
                                                }
                                                }
                                                //onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                                //onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                                //style={{
                                                //    cursor: value.isSequence ? "pointer" : null,
                                                //    width: value.fieldWidth,
                                                //    position: "relative"
                                                // }}

                                                key={index}>
                                                {/*<div style={{*/}
                                                {/*display: "flex",*/}
                                                {/*justifyContent: "center",*/}
                                                {/*alignItems: "center"*/}
                                                {/*}}>*/}
                                                {value.fieldText}
                                                {value.isSequence ?
                                                    <div style={styles.sequenceSvg}>
                                                        <Svg type="Up" width="1rem" height="1rem"
                                                             fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                        <Svg type="Down" width="1rem" height="1rem"
                                                             fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                    </div> :
                                                    null
                                                }

                                                {/*</div>*/}
                                                {/*{<div style={{*/}
                                                {/*cursor: "pointer",*/}
                                                {/*width: value.fieldWidth,*/}
                                                {/*position: "absolute",*/}
                                                {/*display: value.show ? "block" : "none",*/}
                                                {/*background: "#f9f9f9",*/}
                                                {/*boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"*/}
                                                {/*}}>*/}
                                                {/*<div*/}
                                                {/*onMouseOver={this.overColor}*/}
                                                {/*onMouseOut={this.outColor}*/}
                                                {/*style={Object.assign({}, styles.sequenceItem, {*/}
                                                {/*background: state.bgColor,*/}
                                                {/*color: state.textColor*/}
                                                {/*})}*/}
                                                {/*onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>*/}
                                                {/*升序 &nbsp; <Svg type="Up" width="1rem" height="1rem"*/}
                                                {/*fill="#4aa5ff"/>*/}
                                                {/*</div>*/}
                                                {/*<div*/}
                                                {/*onMouseOver={this._overColor}*/}
                                                {/*onMouseOut={this._outColor}*/}
                                                {/*style={Object.assign({}, styles.sequenceItem, {*/}
                                                {/*background: state._bgColor,*/}
                                                {/*color: state._textColor*/}
                                                {/*})}*/}
                                                {/*onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>*/}
                                                {/*降序 &nbsp; <Svg type="Down" width="1rem" height="1rem"*/}
                                                {/*fill="#4aa5ff"/>*/}
                                                {/*</div>*/}
                                                {/*</div>*/}
                                                {/*}*/}

                                            </td> : null
                                    ))}
                                </tr>
                                </thead>
                            </table>


                            {state.tableData.length ? [
                                <table key="1" className="tb-body-1" style={Object.assign({}, styles["tb-body-1"], {
                                    width: lockTabWidth + "rem",
                                })}>
                                    <tbody style={styles.locktbody}>
                                    {state.tableData.map((value, index) => (
                                        <tr key={index}
                                            onClick={this.handleClick.bind(this, value)}
                                            style={Object.assign({},
                                                props.rowBgColor == "none" ? styles[`tbodyTr${2}`] : styles[`tbodyTr${index % 2}`],
                                                {height: props.lineHeight || "2.5rem"})}
                                        >
                                            {props.checkBox ?
                                                value.isChoose ?
                                                    <td style={styles.checkBox}>
                                                        {this.state.itemArr.includes(value.tableId) ?
                                                            <Svg
                                                                type={props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                                width="1rem" height="1rem"
                                                                fill="#4aa5fe"/> :
                                                            <Svg
                                                                type={props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                                width="1rem" height="1rem"
                                                                fill="#ccc"/>
                                                        }
                                                    </td> : <td style={styles.checkBox}></td>
                                                : null
                                            }

                                            {state.tableObj.map((objname, index) => (
                                                objname.isLock ?
                                                    <td title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                        style={{
                                                            width: objname.fieldWidth,
                                                            textOverflow: "ellipsis",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            display: "block"
                                                        }}
                                                        key={index + 'gfy'}>{value[objname.fieldName]}</td> : null
                                            ))
                                            }
                                        </tr>
                                    ))}
                                    {/*<tr key="last"*/}
                                    {/*style={Object.assign({}, styles[`tbodyTr0`], {height: props.lineHeight || "2.5rem"})}>*/}
                                    {/*</tr>*/}

                                    </tbody>
                                </table>,
                                <table key="2" className="tb-body-2" style={Object.assign({}, styles[["tb-body-2"]], {
                                    width: tabBoxWidth + "rem",
                                    left: lockTabWidth + "rem",
                                })}>
                                    <tbody style={styles.tbody}>
                                    {state.tableData.length ?
                                        state.tableData.map((value, index) => (
                                            <tr key={index}
                                                style={Object.assign({},
                                                    props.rowBgColor == "none" ? styles[`tbodyTr${2}`] : styles[`tbodyTr${index % 2}`],
                                                    {height: props.lineHeight || "2.5rem"})}

                                                onClick={this.handleClick.bind(this, value)}
                                            >
                                                {state.tableObj.map((objname, index) => {
                                                    {
                                                        props.checkBox && value.isChoose && !objname.isLock ?
                                                            <td
                                                                style={styles.checkBox}>
                                                                {this.state.itemArr.includes(value.tableId) ?
                                                                    <Svg
                                                                        type={props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                                        width="1rem" height="1rem"
                                                                        fill="#4aa5fe"/> :
                                                                    <Svg
                                                                        type={props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                                        width="1rem" height="1rem"
                                                                        fill="#4aa5fe"/>
                                                                }
                                                            </td> : null
                                                    }
                                                    let dom = [];
                                                    if (index == state.tableObj.length - 1 && objname.fieldName == "operating") {
                                                        dom.push(<td
                                                            title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                            key={index + 'gfy'}
                                                            style={{
                                                                width: objname.fieldWidth,
                                                                textOverflow: "ellipsis",
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                                display: "block",
                                                                boxSizing: "border-box",
                                                                padding: "0 0.4rem",
                                                            }}
                                                            onClick={props.operatingFn ? props.operatingFn.bind(this, value) : () => null}
                                                        >
                                                            <div>查看</div>
                                                        </td>);
                                                    } else {
                                                        dom.push(!objname.isLock ?
                                                            <td title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                                key={index + 'gfy'}
                                                                style={{
                                                                    width: objname.fieldWidth,
                                                                    textOverflow: "ellipsis",
                                                                    overflow: "hidden",
                                                                    whiteSpace: "nowrap",
                                                                    display: "block",
                                                                    boxSizing: "border-box",
                                                                    padding: "0 0.4rem",
                                                                }}>
                                                                {value[objname.fieldName]}
                                                            </td> : null);
                                                    }
                                                    return dom;
                                                })}
                                            </tr>)) :
                                        <tr style={styles.emptyBox}>
                                            <td style={styles.loadBox}>
                                                {props.loading ?
                                                    <div style={styles.loading}>
                                                        正在拼命加载数据中
                                                        {/*<Loading tip={true} tipText={"正在拼命加载数据中..."} />*/}
                                                    </div> :
                                                    <label style={styles.emptyText}>没有找到匹配的数据</label>
                                                }
                                            </td>
                                        </tr>
                                    }
                                    {/*<tr key="last"*/}
                                    {/*style={Object.assign({}, styles[`tbodyTr0`], {height: props.lineHeight || "2.5rem"})}>*/}
                                    {/*</tr>*/}
                                    </tbody>
                                </table>
                            ] : [<div style={{height: "4rem"}}></div>]}


                        </ScrollBox>
                    </div>

                    {!state.tableData.length ? <div style={{
                        position: "absolute",
                        top: "4em",
                        zIndex: "1",
                        width: "100%",
                        textAlign: "center"
                    }}>空空如也</div> : null}

                    {props.hidePage ? null :
                        <div style={Object.assign({}, styles.pageBox, {width: props.width})}>
                            <Page handlePage={props.handlePage}
                                  totalNum={props.totalNum}
                                  pageNumber={props.pageNumber}
                                  pageSize={props.pageSize || 10}
                                  showPageSize={true}
                                  selectData={props.selectData}
                            />
                        </div>

                    }

                </div>

            </div>
        )
    }
}

export default TableField;
